import { ProductComparisonSegmentType } from '../models/product-comparison-segment-type';
import { IProductComparisonSegmentTypeConfiguration } from '../models/product-comparison-segment-type-configuration';

export const fetchSegmentTypeConfiguration = async (configurationId: string, segmentType = ProductComparisonSegmentType.Mixed): Promise<IProductComparisonSegmentTypeConfiguration> => {
  const url = `/public-api/product-comparison/${configurationId}/configuration/${segmentType}`;
  const response: Response = await fetch(url);
  return response.ok ? response.json() : Promise.reject();
};
